import styled from 'styled-components';

import { spaceL, spaceXXL } from '@xing-com/tokens';

export const Wrapper = styled.div`
  min-height: var(--space24);
  padding: ${spaceL} 0 ${spaceXXL} 0;

  @media (--mediaSOnly) {
    min-height: 0;
  }
`;
export const Pagination = styled.div`
  margin-top: ${spaceXXL};
`;

// .meta {
//   color: var(--colorCopyWeak);
//   line-height: var(--lineHeight200);
// }

export const EmptyStateContainer = styled.div`
  margin-top: ${spaceXXL};
`;
